export enum EAppMode {
    DEFAULT = 'default',
    ECOMMERCE = 'ecommerce',
}
